import React from 'react'

const CoScholastic = ({data, handleCoScholasticData}) => {
    
  return (
    <div className="mb-4 flex justify-between space-x-6">
    {/* Scholar Name */}
    <div className="w-full">
      <label className="block text-sm font-bold mb-2">
        Work Education
      </label>
      <select

        name="work_education"
        value={data?.work_education}
        onChange={(e) =>
            handleCoScholasticData("work_education", e.target.value)
        }
        className="w-full p-2 border border-gray-300 rounded-md outline-none"
      >
        <option value="">Select</option>
        <option value="A1">A1</option>
        <option value="A2">A2</option>
        <option value="B1">B1</option>
        <option value="B2">B2</option>
        <option value="C1">C1</option>
        <option value="C2">C2</option>
        <option value="D">D</option>
        <option value="E">E</option>
      </select>
    </div>
    {/* S. R. No. */}
    <div className="w-full ">
      <label className="block text-sm font-bold mb-2">
        Art Education
      </label>
      <select
        name="art_education"
        value={data?.art_education}
        onChange={(e) =>
            handleCoScholasticData("art_education", e.target.value)
        }
        className="w-full p-2 border border-gray-300 rounded-md outline-none"
      >
        <option value="">Select</option>
        <option value="A1">A1</option>
        <option value="A2">A2</option>
        <option value="B1">B1</option>
        <option value="B2">B2</option>
        <option value="C1">C1</option>
        <option value="C2">C2</option>
        <option value="D">D</option>
        <option value="E">E</option>
      </select>
    </div>

    <div className="w-full ">
      <label className="block text-sm font-bold mb-2">
       Health and Physical Education
      </label>
      <select
        value={data?.health_education}
        onChange={(e) =>
            handleCoScholasticData("health_education", e.target.value)
        }
        className="w-full p-2 border border-gray-300 rounded-md outline-none"
      >
        <option value="">Select</option>
        <option value="A1">A1</option>
        <option value="A2">A2</option>
        <option value="B1">B1</option>
        <option value="B2">B2</option>
        <option value="C1">C1</option>
        <option value="C2">C2</option>
        <option value="D">D</option>
        <option value="E">E</option>
      </select>
    </div>
    
    <div className="w-full ">
      <label className="block text-sm font-bold mb-2">
       Discipline
      </label>
      <select
        value={data?.discipline}
        onChange={(e) =>
            handleCoScholasticData("discipline", e.target.value)
        }
        className="w-full p-2 border border-gray-300 rounded-md outline-none"
      >
        <option value="">Select</option>
        <option value="A">A</option>
        <option value="B">B</option>
        <option value="C">C</option>
        <option value="D">D</option>
        <option value="E">E</option>
        <option value="F">F</option>
      </select>
    </div>
  </div>
  )
}

export default CoScholastic
